import {createContext} from 'react';
import {Cart, CartProduct, LineTotal} from "contexts/cart/cart.provider";

interface ContextProps {
    cartState: any;
    dispatch: any;
    toggle: Function;
    add: Function;
    getProductPrice: (price: number, type: string) => number;
    update: Function;
    addCoupon: (id: string) => Promise<void>;
    removeCoupon: Function;
    setOrderStartTime: (date: string) => void;
    setOrderEndTime: (date: string) => void;
    cart: Cart,
    clearCart: Function;
    getProductTripTotal: (product: any, qty?: number) => LineTotal;
    getProduct: (id: string) => CartProduct;
}

export const CartContext = createContext({} as ContextProps);
